import React, { Component } from "react"

/* Constants */
import { utils } from '../constants'

/* Components */
import { Chip3D } from "@cuba-go/poker-ui"
import { CHOICE } from "../constants/status"


/* Component Rates */
class VipRates extends Component {

    getChipsList = () => {
        const { chips } = this.props
        return utils.getChips(chips)
    }

    array_length = (array) => {

        let cnt = 0

        array.forEach(item => {
            if (item) {
                cnt += 1
            }
        })

        return cnt
    }

    /* DRAW ANTE */
    _image = (index) => {

        const { ante, result, chips } = this.props

        const lose = result && result[index] && result[index].result === 'lose'
        const box_ante = ante[index] ? ante[index] : 0

        if (!lose && box_ante) {
            return <Chip3D value={box_ante} chips={chips} size={65} />
        }

        return null
    }


    /* DRAW BET */
    _bet = (index) => {

        const { isBet, ante, gameScreen, chips } = this.props

        const style = gameScreen ? "game" : ""

        const ante_value = ante[index]

        const is_bet = (isBet && isBet[index]) ? isBet[index] : 0

        if (is_bet === 'bet' && ante_value) {
            return (
                <div className={`vip-chip-rate vip-chip-bet ${style}`}>
                    <Chip3D value={ante_value * 2} chips={chips} size={80} />
                </div>
            )
        }

        return null
    }


    /* Draw Bet Result */
    _betResult = (box) => {

        const { result, ante, chips } = this.props

        const boxResult = result[box]

        // const boxResult = { betMultiplier: 3 }

        const chips_position = box === 0 ? "right" : "left"

        const ante_value = ante[box]

        if (boxResult && boxResult.betMultiplier && parseInt(boxResult.betMultiplier) > 0) {

            const value = parseInt(ante_value * 2 * parseInt(boxResult.betMultiplier))

            return (
                <div className="vip-chip-bet-result-multiplier-box">

                    <div className={`vip-chip-bet-result-multiplier-text ${chips_position}`}>{boxResult.betMultiplier}x</div>

                    <div className="vip-chip-bet-result-rate">
                        <Chip3D value={value} chips={chips} size={80} />
                    </div>

                </div>
            )
        }

    }


    /* Draw Ante Result */
    _anteResult = (box) => {

        const { result, ante, chips } = this.props

        let boxResult = result[box]

        const chips_position = box === 0 ? "right" : "left"

        const ante_value = ante[box]

        if (boxResult && boxResult.anteMultiplier && parseInt(boxResult.anteMultiplier) > 0) {

            return (
                <div className="vip-chip-bet-result-multiplier-box">

                    <div className={`vip-chip-bet-result-multiplier-text ${chips_position}`}>{boxResult.anteMultiplier}x</div>

                    <div className="vip-chip-bet-result-rate ante">
                        <Chip3D value={ante_value} chips={chips} size={65} />
                    </div>

                </div>
            )
        }

    }



    /* DRAW BONUS CHIP */
    _bonusImage = (index) => {

        const { bonus, bonusResult, chips } = this.props

        const lose = bonusResult && bonusResult[index] && bonusResult[index].result === "lose"
        const box_bonus = (bonus && bonus[index]) ? bonus[index] : 0

        if (!lose && box_bonus) {
            return <Chip3D value={box_bonus} chips={chips} size={65} />
        }

        return null
    }


    /* Draw Bonus Result */
    _bonusResult = (index) => {

        const { bonusResult, chips } = this.props

        const boxResult = bonusResult ? bonusResult[index] : null

        const chips_position = index === 0 ? "right" : "left"

        if (boxResult && boxResult.result === "win" && parseInt(boxResult.total) > 0) {

            const multiplier = parseInt(boxResult.bonusMultiplier) === 5000 ? "JACKPOT" : `${boxResult.bonusMultiplier}x`

            return (
                <div className="vip-chip-bonus-result-box">

                    <div className={`vip-chip-bonus-result-text ${chips_position}`}>{multiplier}</div>

                    <div className="vip-chip-bonus-result-rate">
                        <Chip3D value={parseInt(boxResult.total)} chips={chips} size={65} />
                    </div>

                </div>
            )
        }
    }


    /* BONUS | прилёт фишки: правый бокс — справа, левый — слева */
    _bonus_animations = (index) => {

        const { history, chips } = this.props

        if (!history) {
            return null
        }

        const chips_position = index === 0 ? "right" : "left"

        return (
            <div className="animations" key={`bonus_animation_${index}`}>
                {history.map((animation, ind) => {

                    if (animation.target === "bonus" && animation.index === index) {
                        return (
                            <div key={`bn_${index}_an_${ind}`} className={`animated-bonus-chip ${chips_position}`}>
                                <Chip3D value={animation.value} chips={chips} size={65} />
                            </div>
                        )
                    }

                    return null
                })}
            </div>
        )
    }


    /* DRAW BONUS | джекпотная ставка, доступна только при withJackpot и при наличии ANTE на боксе */
    _bonus = (index) => {

        const { withJackpot, status, ante, bonus, bonusResult, addBonus } = this.props

        if (!withJackpot) {
            return null
        }

        const chips_position = index === 0 ? "right" : "left"

        const box_ante = ante[index] ? ante[index] : 0
        const box_bonus = (bonus && bonus[index]) ? bonus[index] : 0

        const choice = status === CHOICE
        const lose = bonusResult && bonusResult[index] && bonusResult[index].result === "lose"
        const active = ((choice && box_ante) || box_bonus) && !lose
        const bonus_style = box_bonus && !lose ? "hidden" : ""

        return (
            <div
                onClick={() => (choice && addBonus ? addBonus(index) : null)}
                className={`vip-chips-bottom-bonus ${chips_position}`}
                style={{ opacity: active ? 1 : 0.5 }}
            >
                <div className="vip-outer-box" />
                <div className={`vip-chips-bottom-bonus-text ${bonus_style}`}>BONUS</div>
                {this._bonusImage(index)}
                {this._bonus_animations(index)}
                {this._bonusResult(index)}
            </div>
        )
    }


    /* Animation Chip when opened */
    _animation = (index) => {

        const { ante, isOpen, chips } = this.props
        const box_ante = ante[index]
        const box_is_open = isOpen ? isOpen[index] : 0

        const chips_position = index === 0 ? "right" : "left"

        if (box_is_open && box_ante) {
            return (
                <div className={`vip-chip-open-animation-rate ${chips_position}`}>
                    <Chip3D value={box_ante} chips={chips} size={65} />
                </div>
            )
        }

        return null

    }


    /* Animations */
    _chip_animations = (number) => {
        const { history, chips } = this.props

        if (history) {
            return (
                <div className="animations" key={`chips_animation_${number}`}>
                    {history.map((animation, ind) => {

                        if (animation.index === number - 1 && animation.target !== "bonus") {
                            return (
                                <div key={`ch_${number}_an_${ind}`} className={`animated-chip animated-chip-box-${number}-chip-${animation.key}`}>
                                    <Chip3D value={animation.value} chips={chips} size={65} />
                                </div>
                            )
                        }

                        return null
                    })}
                </div>
            )
        }
    }


    /* Insurance */
    _insurance = (index) => {

        const { insurance, insuranceStatus, chips } = this.props

        const insuranceValue = (insurance && insurance[index]) ? insurance[index] : 0

        const insuranceResult = (insuranceStatus && insuranceStatus[index]) ? insuranceStatus[index] : 0

        let style = "vip-chip-bottom-insurance-title"
        let title = "Страховка"

        if (insuranceResult === "win") {
            style += " vip-chip-bottom-insurance-success-title"
            title = "Страховка выиграла"
        }

        if (insuranceResult === "lose") {
            style += " vip-chip-bottom-insurance-fail-title"
            title = "Страховка проиграла"
        }


        if (insurance && insuranceValue && parseInt(insuranceValue) > 0) {

            const loseStyle = insuranceResult === "lose" ? "vip-chip-bottom-insurance-box pc vip-chip-bottom-insurance-box-lose" : "vip-chip-bottom-insurance-box pc"
            const boxStyle = index === 0 ? 'right' : 'left'

            return (
                <div className={`vip-chip-bottom-insurance ${boxStyle}`}>

                    <div className={style}>
                        {title}
                    </div>

                    <div className={loseStyle}>
                        <div className="vip-insurance-box-shadow" />
                        <Chip3D value={insuranceValue} chips={chips} size={55} />
                    </div>

                    {insuranceResult === "win" &&
                        <div className="vip-chip-bottom-insurance-box-win pc">
                            <div className="vip-insurance-box-shadow" />
                            <Chip3D value={insuranceValue * 2} chips={chips} size={55} />
                        </div>
                    }

                </div>
            )
        }
    }


    render = () => {

        const { status, actions, add, ante, result, active, boxes, isBet, bet, gameScreen, fromBet, dealt, playerGame, sixthGame } = this.props

        const style = gameScreen ? "game" : ""

        const betStyle = fromBet ? 'blured' : ''

        return (
            <div className={`vip-chips-list ${style}`}>
                {
                    boxes.map((_, index) => {

                        const lose = result && result[index] && result[index].result === 'lose'

                        const pass = actions && actions[index] === "pass"

                        const chips_position = index === 0 ? "right" : "left"

                        const box_ante = ante[index] ? ante[index] : 0

                        const is_bet = (isBet && isBet[index] && isBet[index] === 'bet') ? true : false

                        const betHidden = is_bet && !lose ? 'betHidden' : ''

                        const active_bet = (parseInt(box_ante) > 0 || parseInt(active) > 0 || this.array_length(ante))

                        const ante_style = box_ante && !lose && !pass ? "hidden" : ""

                        const chipsShow = !pass && !lose

                        /* ANTE ANIMATION CONDITION */
                        const isAnteAnimated = (status === CHOICE && !box_ante) ? "animated" : ""

                        /* BET ANIMATION CONDITION */
                        const actionChecked = pass || is_bet
                        const boxPlayerGame = playerGame && playerGame[index] ? playerGame[index] : null
                        const boxSixthGame = sixthGame && sixthGame[index] ? sixthGame[index] : null
                        const isBetAnimated = (status !== CHOICE && !actionChecked && ((dealt && boxPlayerGame) || boxSixthGame) && !result[index]) ? "animated" : ""
                        const isBoxDisabled = (status !== CHOICE && !box_ante) ? "disabled" : ""

                        return (
                            <div className={`vip-chips-bottom ${chips_position} ${isBoxDisabled}`} key={`chips_${index}`}>
                                {!active_bet ? <div className="vip-chips-bottom-box">{index + 1} - БОКС</div> : null}

                                {this._animation(index)}

                                {/* <div className="vip-chips-bottom-shadow" /> */}

                                {add !== undefined && add !== null &&
                                    <div onClick={() => add(index)} className={`vip-chips-bottom-ante ${chips_position}`}>
                                        <div className={`vip-outer-box`}>
                                            <div className={active_bet ? `vip-chips-bottom-ante-click ${isAnteAnimated}` : ''} />
                                        </div>

                                        <div className={`vip-chips-bottom-ante-text ${ante_style}`}>ANTE</div>
                                        {chipsShow ? this._image(index) : null}
                                        {this._chip_animations(index + 1)}
                                        {this._anteResult(index)}
                                    </div>
                                }

                                <div onClick={() => bet(index)} className={is_bet ? `vip-chips-bottom-bet-click vip-chips-bottom-bet ${style} ${betStyle}` : `vip-chips-bottom-bet ${style} ${betStyle}`}>
                                    <div className={`vip-outer-box ${isBetAnimated}`} />
                                    <div className={`vip-chips-bottom-bet-text ${betHidden}`}>BET</div>
                                    {chipsShow ? this._bet(index) : null}
                                    {this._betResult(index)}
                                </div>

                                {this._bonus(index)}

                                {this._insurance(index)}

                            </div>
                        )
                    })
                }
            </div>
        )
    }

}

export default VipRates